import { Link } from "gatsby";
import React from "react";
const Logo = () => {
  return (
    <a className="navbar-brand" href={process.env.GATSBY_AVIATION_REDIRECT_URL}>
      <img
        class="d-none d-lg-block"
        src={process.env.GATSBY_IMAGE_URL + "logo.svg"}
        alt="logo"
      />
      <img
        class="d-block d-lg-none"
        src={process.env.GATSBY_IMAGE_URL + "logo.svg"}
        alt="logo"
      />
    </a>
  );
};

export default Logo;
